import { Helmet } from 'react-helmet-async';

const SEO = ({
  title = 'Equi Pulse | SEBI Registered Research Analyst | Stock Market Research India',
  description = 'Equi Pulse is a SEBI registered research analyst offering expert stock market research, equity analysis, and investment insights for Indian markets.',
  keywords = 'SEBI registered research analyst, stock market research India, equity analysis, investment advisory, trading tips',
  image = '/og-image.png',
  url = '',
  type = 'website'
}) => {
  const siteUrl = 'https://www.equipulseresearch.com';
  const fullUrl = url ? `${siteUrl}${url}` : siteUrl;
  const imageUrl = image.startsWith('http') ? image : `${siteUrl}${image}`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={fullUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:site_name" content="Equi Pulse Research" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />
    </Helmet>
  );
};

export default SEO;